<template>
	<v-container>
		<p style="font-size: 18px; margin-left: 10px;">Here, you can create risk matrices and plot your risks in three
			zones: red (high risk), yellow (moderate risk), and green (low risk), based on the consequence and
			probability assigned to each risk. Once plotted, develop action plans directly on the platform to mitigate
			risks. You can track your progress over time to monitor whether risks have decreased or if any improvements
			have been made.</p>
		<v-tabs background-color="transparent" light centered icons-and-text v-model="selectedTab" @change="updateTab">
			<v-tab>
				Active
			</v-tab>
			<v-tab>
				Inactive
			</v-tab>
			<v-tab>
				Completed
			</v-tab>
			<v-tab-item>
				<RiskActive />
			</v-tab-item>
			<v-tab-item>
				<RiskInactive />
			</v-tab-item>
			<v-tab-item>
				<RiskCompleted />
			</v-tab-item>
		</v-tabs>
	</v-container>
</template>

<script>
import RiskActive from "../components/RiskActive.vue"
import RiskInactive from "../components/RiskInactive.vue"
import RiskCompleted from "../components/RiskCompleted.vue"

export default {
	components: {
		RiskActive,
		RiskInactive,
		RiskCompleted,
	},
	data() {
		return {
			selectedTab: 0,
		}
	},
	methods: {
		updateTab(tab) {
			const status = ["Active", "Inactive", "Completed"][tab]
			this.$store.dispatch("updateSelectedStatus", status)
		},
	},
}
</script>
